import { HERO_SIZES } from "../../lib/img";
import { Pic } from "../Pic";
import { DESTINATIONS, VISA_TYPES } from "../../mock";
import { Wordmark } from "../Shared";
import { Flag } from "../Flag";

const INTENT = { Visit: "Visit", Study: "Study abroad", Work: "Work abroad", Employer: "Hire & sponsor", Travel: "Group travel", Family: "Join family", Invest: "Invest & settle", PR: "Permanent residence", Citizenship: "Citizenship", Guides: "Visa help" };
const TYPE_RX = /\b([A-Z][\w-]*(?:\s[A-Z][\w-]*){0,3}\s(?:visa|permit|licence|entry|ETA|eTA|residency))\b/i;

// Pills ranked for search intent: destination (GEO) → visa type (SEO keyword) → intent (AEO/conversion).
export function guidePills(p) {
  const dest = DESTINATIONS.find((d) => d.slug === p.destination);
  const kw = (p.keywords || []).map(String);
  const typeKw = kw.find((k) => TYPE_RX.test(k)) || (p.title.match(TYPE_RX) || [])[1];
  const fallback = VISA_TYPES.find((v) => v.id === (p.category || "").toLowerCase())?.label;
  const type = (typeKw || fallback || "").replace(/^(the|a)\s/i, "");
  const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
  return { dest, pills: [dest?.name, cap(type), INTENT[p.topic] || p.topic].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).slice(0, 3) };
}

export function GuideCover({ p, title, size = "card", className = "" }) {
  const { dest, pills } = guidePills(p);
  const img = p.cover || dest?.image;
  const hero = size === "hero";
  return (
    <div className={`relative h-full w-full overflow-hidden bg-primary ${className}`} data-testid={`guide-cover-${p.slug}`}>
      {img ? <Pic src={img} sizes={HERO_SIZES} alt={dest?.name || ""} eager className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" /> : <div className="h-full w-full bg-[radial-gradient(ellipse_at_top_left,#1f3a70,#13274d_60%)]" />}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#060e20]/85 via-[#060e20]/25 to-transparent" />
      <div className={`absolute left-0 top-0 flex flex-wrap gap-1.5 ${hero ? "p-5 sm:p-6" : "p-3"}`} data-testid={`guide-pills-${p.slug}`}>
        {pills.map((t, i) => <span key={t} className={`rounded-full backdrop-blur ${hero ? "px-3 py-1 text-xs sm:text-sm" : "px-2.5 py-0.5 text-xs"} font-semibold ${i === 0 ? "bg-white/95 text-primary shadow-sm" : "bg-black/45 text-white ring-1 ring-white/30"}`}>{t}</span>)}
      </div>
      <div className={`absolute inset-x-0 bottom-0 ${hero ? "p-5 sm:p-7" : "p-3.5"}`}>
        {title && <p className={`font-semibold leading-snug text-white [text-shadow:0_1px_2px_rgba(0,0,0,.35)] ${hero ? "max-w-2xl text-2xl sm:text-4xl" : "line-clamp-2 text-base"}`}>{title}</p>}
        <div className={`${title ? (hero ? "mt-4" : "mt-2.5") : ""} flex items-center gap-2`}><Wordmark light size={hero ? "text-2xl" : "text-lg"} />{dest && <span className={`inline-flex items-center gap-1.5 ${hero ? "text-sm" : "text-xs"} text-on-dark`}>· <Flag flag={dest.flag} size={hero ? 16 : 13} /> {dest.name}</span>}</div>
      </div>
    </div>
  );
}
